export default __webpack_public_path__ + "static/media/reveria.a148742f.jpg";